import React from 'react';

import CheckIcon from '@repo/ui/components/Icon/CheckIcon';
import { useNewThemeActive } from '@repo/ui/theming';

import { Box, CheckIconWrapper } from './styles';
import { defaultTheme, newDefaultTheme } from './theme';
import { CheckboxProps } from './types';

const Checkbox: React.FC<CheckboxProps> = ({ value = false, ...props }) => {
  const isNewThemeActive = useNewThemeActive();

  const theme = {
    ...defaultTheme,
    ...(isNewThemeActive ? newDefaultTheme : {}),
    ...props.theme,
  };

  return (
    <Box
      checked={value}
      className={props.className}
      data-testid={props.dataTestId}
      theme={theme}
      onClick={props.onClick}
    >
      {value && (
        <CheckIconWrapper data-testid="check-icon">
          <CheckIcon
            height={theme.checkIconSize}
            theme={{ color: theme.checkColor }}
          />
        </CheckIconWrapper>
      )}
    </Box>
  );
};

export default Checkbox;
